module.exports = __webpack_public_path__ + "i18n/nl.8b1131e2f473c277cda3e65f557b11fe.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1002
// module chunks = 60